import { createSelector } from "reselect";
import { RootState } from "../types";

export const selectAppState = (state: RootState) => state.app;

export const selectAppLoading = createSelector(
  [selectAppState],
  (app): boolean => app.loading
);

export const selectAppError = createSelector(
  [selectAppState],
  (app): string | null => app.error
);
